var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.homepage && _vm.$vuetify.breakpoint.smAndUp)?_c('v-row',[_c('v-col',[_c('ObjectImages',{attrs:{"images":_vm.computedHotImages,"img-folder":'objectImages/large'}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }